var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 49L5 33L60 5L50 49Z",
    fill: "#8A6CC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7002 41.8L50.0002 49L60.0002 5L29.7002 41.8Z",
    fill: "#8A6CC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 38L29 59V41L60 5L20 38Z",
    fill: "#624B93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59L37.3 44.5L29 41.5V59Z",
    fill: "url(#paint0_linear_191_2667)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2667",
    x1: 31.573,
    y1: 51.828,
    x2: 34.239,
    y2: 36.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#624B93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.b9fabd6c2b1c9e1156ca6ce409308f86.svg";
export { ForwardRef as ReactComponent };